'use strict';
angular.module('openDataApp')
  .directive('disableKeyboardArrows', function () {
    const keyboardEvent = function(event) {
      if(event.keyCode === 38 || event.keyCode === 40) {
        event.preventDefault();
      }
    };

    return {
      link: function(scope, element) {
        element.on('keydown', keyboardEvent);
      }
    };
  });
